import { FC, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { BoardContext, CardContext, SocketContext, TeamContext, UserContext } from "../../../context";
import { useSound } from "../../../hooks";

const PostMatchSummaryMolecule: FC<{}> = () => {
    const { t } = useTranslation();
    const { socket } = useContext(SocketContext);
    const { teamNumber } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const { threeActions, setThreeActions } = useContext(CardContext);
    const [action, setAction] = useState({
        first: "",
        second: "",
        third: ""
    });
    const {playSound, stopSound} = useSound();

    const [actionableInterestingMeaningful, setActionsInterestingMeaningful] = useState("");

    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];
 
    useEffect(() => {
        socket?.disconnect();
    }, [socket]);

    useEffect(() => {
		const elevatorMusic = setTimeout( () => {
            playSound("/sounds/slotmachineintro.mp3");
        });

        return () => clearTimeout(elevatorMusic);
	}, [playSound]);

    const handleChange = (type: string, event: any) => {
        if (type === "actionableInterestingMeaningful"){ 
            setActionsInterestingMeaningful(event.target.value);
        }

        if (type === "first_action") {
            setAction({ ...action, first: event.target.value});
        }

        if (type === "second_action") {
            setAction({ ...action, second: event.target.value});
        }

        if (type === "third_action") {
            setAction({ ...action, third: event.target.value});
        }
    }

    const handleSubmit = () => {

        stopSound();

        let data = {
            matchId: urlTokenExtracted,
            gameId: urlTokenExtracted + "/" + teamNumber,
            email: userData?.email,
            actionableInterestingMeaningful: actionableInterestingMeaningful || t("youDidnotEnterAnythingText"),
            threeActions: {
                one: action.first || t("NAText"),
                two: action.second || t("NAText"),
                three: action.third || t("NAText")
            }
        }

        localStorage.setItem("actionableInterestingMeaningful", actionableInterestingMeaningful || t("youDidnotEnterAnythingText"));
        localStorage.setItem("actionOne", action.first || t("NAText"));
        localStorage.setItem("actionTwo", action.second || t("NAText"));
        localStorage.setItem("actionThree", action.third || t("NAText"));

        fetch(process.env.REACT_APP_BACKEND_URL + "api/post-games/summary-pdf", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(() => console.log(''))
            .catch((err) => {
                console.error(err);
            });
    }


    return (
        <form onSubmit={handleSubmit}>

            <div className="summary_section">
                <div className="summary_section__label">
                    <label> {t("pleaseCommitTo3ActionsYouWnatText")} <br></br> {t("followingYourLearningText")}: </label>
                </div>
                <div className="text_area__wrapper">
                    <textarea
                        value={action.first}
                        onChange={(event) => handleChange("first_action", event)}
                        placeholder={t("interestingText")}
                        style={{height: "60px"}}
                        cols={30}
                        rows={1} 
                        onBlur={() => setThreeActions({...threeActions, first: action?.first}) }
                        maxLength={100} />

                    <textarea
                        value={action.second}
                        onChange={(event) => handleChange("second_action", event)}
                        placeholder={t("actionableText")}
                        style={{height: "60px"}}
                        cols={30}
                        rows={1} 
                        onBlur={() => setThreeActions({...threeActions, second: action?.second}) } 
                        maxLength={100} />

                    <textarea
                        value={action.third}
                        onChange={(event) => handleChange("third_action", event)}
                        placeholder={t("meaningfulText")}
                        style={{height: "60px"}}
                        cols={30}
                        rows={1} 
                        onBlur={() => setThreeActions({...threeActions, third: action?.third}) }
                        maxLength={100} />
                </div>
            </div>
        </form>
    );
};

export default PostMatchSummaryMolecule;
